import script from "./FreezeList.vue?vue&type=script&setup=true&lang=js"
export * from "./FreezeList.vue?vue&type=script&setup=true&lang=js"

import "./FreezeList.vue?vue&type=style&index=0&id=76a3b79a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a3b79a"]])

export default __exports__